import { useState } from "react";

import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import TextPanel from "../../common/TextPanel";
import GenrateDocument from "../../GenrateDocument/GenrateDocument";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import PanelActionBarComponent from "../../common/PanelActionBarComponent";

const OutsideRepresentaion = () => {
  const [showDocument, setShowDocument] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);

  const handleGenrateDocument = (instanceId) => {
    setInstanceIdForGenragteDoc(instanceId);
    setShowDocument(true);
  };

  const DogBiteLocBtn = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: (id, name) => handleGenrateDocument(id, name),
    },
  ];

  return (
    <>
      <PanelActionBarComponent
        // panelIconSrc={InsuranceIcon}
        page_id={72}
        name={"Name"}
        type="Type"
      />

      <div
        className="d-flex m-t-5 m-b-5"
        style={{
          gap: "5px",
        }}
      >
        <div className="d-flex flex-wrap" style={{ gap: "5px", width: "100%" }}>
          {/*  */}
          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={""}
              panel_name="Party Location"
              className="m-b-0"
              pageName={"Wrongful"}
              websiteURL={""}
              name={""}
              address1={""}
              address2={""}
              city={""}
              state={""}
              zip_code={""}
              phone_number={""}
              email={""}
              onSelectObject={() => {}}
              buttonData={DogBiteLocBtn}
              genrate_doc_address=""
            />
          </div>

          <div className="min-w-260px-client">
            <TextPanel
              object={{
                statement_summary: "",
              }}
              panel_name="Relationship to Deceseased"
              className="info-div-accident-statement-summary"
              primaryText="Click to add Relationship to deceased"
            />
          </div>

          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={""}
              panel_name="Firm Location"
              className="m-b-0"
              pageName={"WrongDeath"}
              websiteURL={""}
              name={""}
              address1={""}
              address2={""}
              city={""}
              state={""}
              zip_code={""}
              phone_number={""}
              email={""}
              onSelectObject={() => {}}
              buttonData={DogBiteLocBtn}
              genrate_doc_address=""
            />
          </div>

          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={""}
              panel_name="Attorney Location"
              className="m-b-0"
              pageName={"WrongDeath"}
              websiteURL={""}
              name={""}
              address1={""}
              address2={""}
              city={""}
              state={""}
              zip_code={""}
              phone_number={""}
              email={""}
              onSelectObject={() => {}}
              buttonData={DogBiteLocBtn}
              genrate_doc_address=""
            />
          </div>

          <div
            className=""
            style={{
              flex: 1,
              minHeight: "155px",
              maxHeight: "155px",
              paddingRight: "0px",
              scrollbarWidth: "none",
              minWidth: "400px",
            }}
          >
            <p className="menu-bar-style columnsTitle text-center">Notes</p>

            <TreatmentNotesSection
              entity_type={"WrongDeath"}
              record_id={""}
              module={"WrongDeath"}
              pagePanels={0}
            />
          </div>
        </div>
      </div>
      {showDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => setShowDocument(false)}
          PageEntity="WrongDeath"
          instanceId={instanceIdForGenrateDoc}
        />
      )}
    </>
  );
};

export default OutsideRepresentaion;
